import { AtSign, Instagram } from 'lucide-react';
import { cn } from '@/lib/utils';

const INSTAGRAM_URL = 'https://instagram.com/dugoutdesk';
const X_URL = 'https://x.com/DugoutDesk';
const THREADS_URL = 'https://www.threads.net/@dugoutdesk';

const iconSize = { default: 20, compact: 16 };

function XIcon({ size }: { size: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  );
}

interface SocialLinksProps {
  variant?: 'default' | 'compact';
  className?: string;
}

export function SocialLinks({ variant = 'default', className }: SocialLinksProps) {
  const size = iconSize[variant];
  const linkClass = cn(
    'inline-flex shrink-0 items-center justify-center rounded-lg text-muted-foreground transition-colors hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 touch-manipulation',
    variant === 'default' && 'w-12 h-12 p-2',
    variant === 'compact' && 'w-12 h-12 p-2',
    className
  );
  return (
    <>
      <a
        href={X_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Follow us on X (@DugoutDesk)"
        className={linkClass}
      >
        <XIcon size={size} />
      </a>
      <a
        href={THREADS_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Follow us on Threads (@dugoutdesk)"
        className={linkClass}
      >
        <AtSign className={cn(variant === 'default' ? 'w-5 h-5' : 'w-4 h-4')} aria-hidden />
      </a>
      <a
        href={INSTAGRAM_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Follow us on Instagram"
        className={linkClass}
      >
        <Instagram className={cn(variant === 'default' ? 'w-5 h-5' : 'w-4 h-4')} aria-hidden />
      </a>
    </>
  );
}
